export default function DemoLight() {
  return (
    <>
      <a href="#request-a-demo" className="btn-blue">
        Request a Demo
      </a>
    </>
  )
}
